import { useId, useState, type FormEvent } from 'react';
import { fetchSpikeConfig, SpikeApiError } from './api';
import { storeToken } from './storage';

export function TokenGate({ onUnlock }: { onUnlock: (token: string) => void }) {
  const id = useId();
  const [value, setValue] = useState('');
  const [checking, setChecking] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    const token = value.trim();
    if (!token) return;
    setChecking(true);
    setError(null);
    try {
      await fetchSpikeConfig(token);
      storeToken(token);
      onUnlock(token);
    } catch (err) {
      setError(
        err instanceof SpikeApiError && err.status === 401
          ? "That token isn't right. Check it and try again."
          : "Couldn't check the token. Check your connection and try again.",
      );
    } finally {
      setChecking(false);
    }
  }

  return (
    <section className="card" data-state="locked" aria-labelledby={`${id}-title`}>
      <h2 id={`${id}-title`} className="card-heading">
        Enter the admin token
      </h2>
      <p className="card-detail">
        This page is for testing on your iPhone. The token was sent to you in chat; it's remembered
        on this device only.
      </p>
      <form onSubmit={(e) => void submit(e)} className="stack">
        <label htmlFor={id}>Admin token</label>
        <input
          id={id}
          type="password"
          autoComplete="off"
          autoCapitalize="off"
          spellCheck={false}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        {error && (
          <p role="alert" className="error-text">
            {error}
          </p>
        )}
        <button type="submit" className="primary" disabled={checking || value.trim() === ''}>
          {checking ? 'Checking…' : 'Unlock'}
        </button>
      </form>
    </section>
  );
}
